<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">
                                            <h5 class="m-b-10">Applicant Scorecards</h5>

                                            <div class="table-responsive">
                                                <input type="text" class="form-control" v-model="starred_filter"
                                                    placeholder="Search...">
                                                <datatable :columns="scorecard_columns" :data="score_cards" :filter-by="starred_filter"
                                                    name="score_cards_table"></datatable>
                                                <span v-if="score_cards.length < 1">No Scorecards to show.</span>
                                                <div v-else>
                                                    <h5>Scorecard Average Score: <b>{{parseFloat(score_card_average).toFixed(2)}}</b></h5>
                                                    <h5>Maximum Possible Score: <b>{{ scorecard_max_score }}</b></h5>
                                                    <h5>Average Score Percentage: <b>{{parseFloat(score_card_average_percent).toFixed(2)
                                                            }}%</b></h5>
                                                </div>

                                                <div class="" style="text-align: center;">
                                                    <datatable-pager v-model="page" type="long" :per-page="per_page"
                                                        table="score_cards_table"></datatable-pager>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active {
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {
        background-color: #00ff00;
    }

    .small_info {
        font-size: 10px;
    }
</style>
<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'

    export default {
        name: 'AllScoreCards',

        data() {
            return {
                starred_filter: '',
                page: 1,
                per_page: 10,
                scorecard_columns: [
                    { label: 'Evaluatore ID', field: 'id' },
                    {
                        label: 'Evaluator Name', representedAs: (row) => {
                            return row.first_name + " " + row.last_name
                        }
                    },
                    {
                        label: "Hiring  Decision", representedAs: (row) => {
                            var evals = row.evaluations
                            return evals[0].hiring_decision

                        },
                    }, {

                        label: 'Applicant Score', representedAs: (row) => {
                            var evals = row.evaluations
                            var score = 0
                            for (var i = 0; i < evals.length; i++) {
                                score = score + parseInt(evals[i].score)
                            }
                            return score

                        },
                    },
                    {
                        label: 'Actions', representedAs: (row) => {
                            return '<a target="_blank" href="/scorecard/' + this.$route.params.id + '/?evaluator=' + row.id + '" class="btn btn-sm btn-success m-1" data-target="#viewDiscontinued' + row.id + '">View</a>'
                        }, interpolate: true
                    }
                ],

                score_cards: [],
                score_card_average: "",
                score_card_average_percent: "",
                scorecard_max_score: "",
                hire_decision: "",
            }
        },

        components: {
            navbar1,
            navbar2
        },

        mounted() {
            $('.theme-loader').hide()

            this.getAllScoreCards()

            //this.getRoleNameById('23')
        },
        methods: {

            getAllScoreCards() {

                var scorecards = {
                    what: 'ApplicantScorecard',
                    params: {
                        appID: this.$route.params.id
                    }
                }

                this.$socket.makeGetRequest(scorecards)
                    .then((response) => {
                        if (response.type == 'ApplicantScorecard') {
                            this.score_cards = response.data
                            console.log(response.data)

                            //Variable to hold the total score
                            var cumulative = 0

                            //Variable to hold the number of "things to evaluate" per scorecard
                            var max_score = 0

                            for (var h = 0; h < this.score_cards.length; h++) {
                                var evals = this.score_cards[h].evaluations
                                this.hire_decision = evals[h].hiring_decision
                                var hire_decision = this.hire_decision

                                var score = 0
                                /*
                                    To get the max score possible for the scorecard, we multiply the number of 
                                    "things to evaluate" by 5, since 5 is the maximum possible score per "thing".
                                */
                                max_score = (max_score < (parseInt(evals.length) * 5)) ? parseInt(evals.length) * 5 : max_score

                                for (var i = 0; i < evals.length; i++) {
                                    score = score + parseInt(evals[i].score)
                                }
                                cumulative = cumulative + score
                            }

                            this.score_card_average = cumulative / this.score_cards.length
                            this.scorecard_max_score = max_score
                            this.score_card_average_percent = (this.score_card_average / this.scorecard_max_score) * 100
                        }

                    })
                    .catch((e) => {
                        console.log(e)
                    })
            }
        },
        computed: {

        }
    }
</script>